import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HiX, HiOutlineTrash, HiOutlineExclamationCircle } from "react-icons/hi";

const DeleteModal = ({ isOpen, onClose, item, type, onConfirm, isProcessing }) => {
  if (!item) return null;

  return (
    <AnimatePresence mode="wait">
      {isOpen && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={!isProcessing ? onClose : undefined}
            className="absolute inset-0 bg-slate-900/40 backdrop-blur-md"
          />

          {/* Modal Container */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            className="relative w-full max-w-md bg-white rounded-[2.5rem] shadow-2xl overflow-hidden border border-slate-100"
          >
            <div className="p-8">
              {/* Header Visual with Hexagon-like feel (consistency) */}
              <div className="flex justify-center mb-8">
                <div className="relative">
                  <div className="w-24 h-24 bg-amber-50 rounded-[2rem] flex items-center justify-center text-amber-500 shadow-inner">
                    <HiOutlineTrash size={40} className={isProcessing ? "animate-pulse" : ""} />
                  </div>
                  <div className="absolute -bottom-2 -right-2 bg-white p-2 rounded-xl shadow-lg border border-amber-100">
                    <HiOutlineExclamationCircle className="text-amber-500" size={20} />
                  </div>
                </div>
              </div>

              {/* Text Content */}
              <div className="text-center mb-10">
                <h3 className="text-2xl font-black text-slate-800 mb-3 tracking-tight">
                    Move to Trash?
                </h3>
                <p className="text-sm text-slate-500 font-medium px-4 leading-relaxed">
                  You're about to move <span className="text-indigo-600 font-bold">"{item.name}"</span> to the graveyard. 
                  <span className="block mt-2 font-bold text-slate-400 uppercase text-[9px] tracking-[0.2em]">You can recover it anytime from the trash.</span>
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col gap-3">
                <button
                  disabled={isProcessing}
                  onClick={() => onConfirm(item, type)}
                  className="w-full px-8 py-4 bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-300 text-white rounded-2xl font-black shadow-xl shadow-indigo-100 transition-all active:scale-95 flex items-center justify-center gap-3 uppercase tracking-widest text-[11px]"
                >
                  {isProcessing ? (
                    <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  ) : (
                    <HiOutlineTrash size={18} />
                  )}
                  {isProcessing ? "Processing..." : "Trash Item"}
                </button>
                <button
                  disabled={isProcessing}
                  onClick={onClose}
                  className="w-full px-6 py-4 bg-slate-50 hover:bg-slate-100 text-slate-400 hover:text-slate-600 rounded-2xl font-bold transition-all active:scale-95 text-xs uppercase tracking-widest"
                >
                  Keep in Drive
                </button>
              </div>
            </div>

            {/* Subtle Close Button */}
            {!isProcessing && (
                <button 
                onClick={onClose}
                className="absolute top-6 right-6 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-xl transition-all"
                >
                <HiX size={20} />
                </button>
            )}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default DeleteModal;
